
import { defineComponent, ref, inject, computed, provide } from "vue"
import { useI18n } from "vue-i18n/index";
//components
import ModalNominal from "@/views/tournaments/Modals/ModalNominal.vue"
//import ModalNominal from "@/components/modals/general/ModalNominal.vue"
import MixedWidget1 from "@/components/widgets/mixed/Widget1.vue";
import MixedWidget14 from "@/components/widgets/mixed/Widget14.vue";
import ModalListOrdersPays from "./ModalListOrdersPays.vue";

//icons
import { Search, ArrowLeft } from '@element-plus/icons-vue'

//services
import eventService from "@/core/services/EventService";
import sportService from "@/core/services/SportService";
import { errManager, mbtoa, DownloadFile } from "@/core/config/Tools";

import axios from "axios";
import moment from 'moment';
import GlobalService from "@/core/services/GlobalService";
moment.locale("es");

export default defineComponent({
    name: "ModalSport",
    components: { MixedWidget1, MixedWidget14, ModalNominal, ModalListOrdersPays },
    props: {
        evento: {
            type: Object,
            required: true,
            default: {}
        },
        sport: {
            type: Object,
            required: true,
            default: {}
        },
        listSports: {
            type: null,
            required: true,
            default: []
        },
        listStatus: {
            type: null,
            required: true,
            default: []
        }
    },

    setup(props) {
        const { t } = useI18n();
        const heightTable = window.screen.height - 460
        const REPO = ref(process.env.VUE_APP_REPO);
        const dialogSport = inject<any>('dialogSport');
        const dialogNominal = ref(false)
        const listInstitutions = ref<any>([])
        const allInstitutions = ref<any>([])
        const listRTRegister = ref<any>([])
        const listRCheckDoc = ref<any>([])
        const listRGender = ref<any>([])
        const idsport = ref()
        const rowClub = ref({})
        const idcheckdoc = ref<any>([])
        const sportDetails = ref<any>({})
        const total = ref(0)
        const idInstitution = ref<any>({})
        const ModalListOrdersPaysRef = ref<any>(null);
        const selectionClubs = ref<any[]>([]);

        //provides shared data
        provide("dialogNominal", dialogNominal)

        //loaders
        const loader = ref(false)
        const loaderTable = ref(false);
        const loadingClub = ref(false);
        const loadingDownload = ref(false);

        //search
        const searchClub = ref("");

        const callDownloadFile = (ext: string, target: string, payload: any) => {
            DownloadFile(ext, target, payload, loadingDownload);
        };

        //methods
        const opened = () => {
            idsport.value = props.sport.idsport
            setStatus();
            getListClubs();
            Closure();
            getSummary();
        }

        const onBack = () => {
            dialogSport.value = false
        }

        const setStatus = () => {
            if (idcheckdoc.value.length == 0) {
                idcheckdoc.value.length = 0
                props.listStatus.forEach((element: any) => {
                    idcheckdoc.value.push(element.id)
                });
            }
        }

        const changeSport = () => {
            getListClubs();
            Closure();
            getSummary();
        }

        const getAllClubs = async (query: string) => {
            if (query.trim()) {
                loadingClub.value = true;
                await GlobalService.get('api', `institution?search=${query.toLowerCase()}`)
                .then((res)=>{
                    allInstitutions.value = res.data.data;
                    loadingClub.value = false;
                }).catch(({response})=>{
                    loadingClub.value = false;
                    errManager(response);
                })
            } else {
                allInstitutions.value = [];
            }
        };

        const getListClubs = async () => {
            loaderTable.value = true
            listInstitutions.value.length = 0
            await eventService.getClubs({
                idevent: props.evento?.idevent,
                idsport: idsport.value,
                checkdoc: idcheckdoc.value
            })
                .then((res) => {
                    loaderTable.value = false
                    listInstitutions.value = res.data
                }).catch(({ response }) => {
                    loaderTable.value = false
                    errManager(response)
                })
        }

        const filteredClubs = computed(() => {
            const search = searchClub.value?.toLowerCase().trim() || '';

            if (!search) {
                return listInstitutions.value;
            }

            return listInstitutions.value.filter((item) => {
                const abrev = item.abrev?.toLowerCase().trim() || '';
                const business = item.name?.toLowerCase().trim() || '';

                return abrev.includes(search) || business.includes(search);
            });
        });

        const Closure = async () => {
            await sportService.getClosure({ idevent: props.evento?.idevent, idsport: idsport.value })
                .then((res) => {
                    sportDetails.value = res.data
                }).catch(({ response }) => {
                    errManager(response)
                })
        }

        const getSummary = async () => {
            listRTRegister.value.length = 0
            listRCheckDoc.value.length = 0
            total.value = 0
            listRGender.value.length = 0
            await eventService.summary({ idevent: props.evento?.idevent, idsport: idsport.value, checkdoc: idcheckdoc.value })
                .then((res) => {
                    listRTRegister.value = res.data.rtregister
                    listRCheckDoc.value = res.data.rcheckdoc
                    listRGender.value = res.data.rgender
                    listRGender.value.forEach(element => {
                        total.value += parseInt(element.quantity)
                    });
                }).catch(({ response }) => {
                    errManager(response)
                })
        }

        //open dialog nominal
        const openDialogNominal = (row) => {
            rowClub.value = row
            dialogNominal.value = true
        }

        const oClosed = () => {
            listInstitutions.value.length = 0;
            allInstitutions.value.length = 0;
            listRTRegister.value.length = 0;
            listRCheckDoc.value.length = 0;
            listRGender.value.length = 0;
        };

        // Excluir columnas fijas
        const fixedColumns = ["idinstitution", "abrev", "name", "quantity", "avatar", "flags", "idcountry", "country"];
        const dynamicColumns = computed(() => {
            if (listInstitutions.value.length === 0) return [];
            return Object.keys(listInstitutions.value[0])
                .filter((key) => !fixedColumns.includes(key))
                .map((key) => ({
                    prop: key,
                    label: key.charAt(0).toUpperCase() + key.slice(1),
                    width: "120",
                    align: "center",
                }));
        });

        const openDialogOrders = (row: any) => {
            if(ModalListOrdersPaysRef.value){
                rowClub.value = row;
                ModalListOrdersPaysRef.value.openModal();
            }
        };

        const handleSelectionChange = (selection: any[]) => {
            selectionClubs.value = selection.map(item => item.idinstitution)
        }

        return {
            t,
            REPO,
            heightTable,
            //variables
            dialogSport,
            dialogNominal,
            idsport,
            rowClub,
            idcheckdoc,
            searchClub,
            sportDetails,
            idInstitution,
            ModalListOrdersPaysRef,
            selectionClubs,

            //icons
            Search,
            total,
            ArrowLeft,

            //list
            listInstitutions,
            allInstitutions,
            listRTRegister,
            listRCheckDoc,
            listRGender,

            //loaders
            loaderTable,
            loader,
            loadingClub,
            loadingDownload,
            dynamicColumns,

            //methods
            onBack,
            opened,
            oClosed,
            changeSport,
            getListClubs,
            getAllClubs,
            filteredClubs,
            Closure,
            getSummary,
            openDialogNominal,
            callDownloadFile,
            mbtoa,
            openDialogOrders,
            handleSelectionChange
        }

    },
})
